import { render, staticRenderFns } from "./cooperDetail.vue?vue&type=template&id=e3ae8c00&scoped=true&"
import script from "./cooperDetail.vue?vue&type=script&lang=js&"
export * from "./cooperDetail.vue?vue&type=script&lang=js&"
import style0 from "./cooperDetail.vue?vue&type=style&index=0&id=e3ae8c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ae8c00",
  null
  
)

export default component.exports